const SDI_IMPORTANCE = {
    HIGH: "HIGH",
    MEDIUM: "MEDIUM",
    LOW: "LOW"
};

const DISCLAIMER = {
    SENTINEL_UI: "Sentinel uses AI engines that may occasionally misidentify, misclassify, or inadequately encrypt, mask, or protect sensitive information.",
    SENTINEL_REPORT: "AI features are not always accurate or error-free, and you acknowledge and agree that Striim AI (including Sentinel AI) may not properly detect, classify, or encrypt, mask, or otherwise protect all sensitive and other targeted information.",
    SHERLOCK_UI: "Sherlock uses AI engines that may occasionally misidentify or misclassify sensitive information.",
    SHERLOCK_REPORT: "AI features are not always accurate or error-free, and you acknowledge and agree that Striim AI (including Sherlock AI) may not properly detect or classify all sensitive and other targeted information."
}

export { SDI_IMPORTANCE, DISCLAIMER }
